import axios from 'axios';
import { CLINIC_LOCATION_ROUTE } from '../api/backend';
import { HormoneSummaryResponse } from '../common/model/dto/hormone-summary';
import { SimilarPatientsResponse } from '../common/model/dto/similar-patients';
import { StrawStageApiResponse } from '../common/model/dto/straw-stage/straw-stage-api-response';
import { UserCycle } from '../common/model/dto/user-cycle/user-cycle';
import { Paginated } from '../common/types';

const patientRoute = (clinicLocationId: string, patientId: string) =>
  `${CLINIC_LOCATION_ROUTE}/${clinicLocationId}/patients/${patientId}`;

export const clinicLocationClinicalDataQueryKeys = {
  cycles: (
    clinicLocationId: string | undefined,
    patientId: string | undefined,
    query = ''
  ) =>
    [
      'clinic-location-patient-cycles',
      clinicLocationId,
      patientId,
      query,
    ] as const,
  similarPatients: (
    clinicLocationId: string | undefined,
    patientId: string | undefined
  ) =>
    [
      'clinic-location-patient-similar-patients',
      clinicLocationId,
      patientId,
    ] as const,
};

export async function getPatientReproductiveStage(
  clinicLocationId: string,
  patientId: string
): Promise<StrawStageApiResponse> {
  const { data } = await axios.get<StrawStageApiResponse>(
    `${patientRoute(clinicLocationId, patientId)}/straw-stage`
  );

  return data;
}

export async function getPatientCycles(
  clinicLocationId: string,
  patientId: string,
  query = ''
): Promise<Paginated<UserCycle>> {
  const { data } = await axios.get<Paginated<UserCycle>>(
    `${patientRoute(clinicLocationId, patientId)}/cycles${
      query ? `?${query}` : ''
    }`
  );

  return data;
}

export async function getPatientCycleHormoneSummary(
  clinicLocationId: string,
  patientId: string,
  cycleId: string
): Promise<HormoneSummaryResponse> {
  const { data } = await axios.get<HormoneSummaryResponse>(
    `${patientRoute(clinicLocationId, patientId)}/cycles/${cycleId}/summary`
  );

  return data;
}

export async function getPatientSimilarPatients(
  clinicLocationId: string,
  patientId: string
): Promise<SimilarPatientsResponse> {
  const { data } = await axios.get<SimilarPatientsResponse>(
    `${patientRoute(clinicLocationId, patientId)}/similar-patients`
  );

  return data;
}
